export const getBaseUrl = (api: string) => {
  let environment = process.env.REACT_APP_API_ENV ?? '';
  //@ts-ignore
  if (window.Cypress) {
    environment = process.env.REACT_APP_CYPRESS_API_ENV ?? '';
    return dhlEnvironmentMap[environment][api];
  }
  return dhlEnvironmentMap[environment][api];
};

export const dhlEnvironmentMap: any = {
  QA: {
    security: 'https://cra-api-dev-opsh4.dhl.com/security-mx/api',
    locker: 'https://cra-api-dev-opsh4.dhl.com/lockers-mx/api',
    companies: 'https://cra-api-dev-opsh4.dhl.com/companies-mx/api',
  },
  PROD: {
    security: 'https://cra-api-opsh4.dhl.com/security-mx/api',
    locker: 'https://cra-api-opsh4.dhl.com/lockers-mx/api',
    companies: 'https://cra-api-opsh4.dhl.com/companies-mx/api',
  },
};
